import { TerminalDemo } from './components/terminal-demo'
import { EcosystemGrid } from './components/ecosystem-grid'
import { PricingSection } from './components/pricing-section'

const STEPS = [
  { num: '1', title: 'Describe your goal', desc: 'Natural language input. "Build a landing page for my cafe."' },
  { num: '2', title: 'AI plans & executes', desc: 'Plan, Execute, Verify — fully autonomous. Self-heals on errors.' },
  { num: '3', title: 'Pay per result', desc: '1-5 MCU per task. Only charged after successful delivery.' },
  { num: '4', title: 'Get deliverables', desc: 'Files, links, deployed apps — ready in minutes with full audit trail.' },
]

function App() {
  return (
    <>
      {/* Header */}
      <header className="header">
        <div className="logo"><span>AgencyOS</span></div>
        <nav className="nav">
          <a href="#ecosystem">Ecosystem</a>
          <a href="#pricing">Pricing</a>
          <a href="https://docs.agencyos.network" target="_blank" rel="noopener noreferrer">Docs</a>
          <a href="https://app.agencyos.network" className="btn btn-primary" style={{ padding: '0.5rem 1.25rem', fontSize: '0.8rem' }}>
            Dashboard
          </a>
        </nav>
      </header>

      {/* Hero */}
      <section className="hero">
        <h1>
          AI-Operated<br />
          <span className="gradient">Business Platform</span>
        </h1>
        <p>
          All your agents in one dashboard. 342 commands across 6 operational layers.
          From founder strategy to engineering execution — fully autonomous.
        </p>
        <div className="hero-buttons">
          <a href="https://raas.agencyos.network" className="btn btn-primary">
            Start Free
          </a>
          <a href="https://docs.agencyos.network" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
            Read the Docs
          </a>
        </div>
      </section>

      {/* Stats */}
      <div className="stats-bar">
        <div className="stat"><div className="stat-value">342+</div><div className="stat-label">Commands</div></div>
        <div className="stat"><div className="stat-value">6</div><div className="stat-label">Op Layers</div></div>
        <div className="stat"><div className="stat-value">50+</div><div className="stat-label">API Endpoints</div></div>
        <div className="stat"><div className="stat-value">$0</div><div className="stat-label">Infra Cost</div></div>
      </div>

      {/* Terminal Demo */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">See It In Action</h2>
          <p className="section-subtitle">
            One command. AI plans, executes, verifies, and delivers.
          </p>
          <TerminalDemo />
        </div>
      </section>

      {/* Ecosystem */}
      <div id="ecosystem">
        <EcosystemGrid />
      </div>

      {/* How It Works */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">How It Works</h2>
          <p className="section-subtitle">Four steps from goal to verified deliverable.</p>
          <div className="steps-grid">
            {STEPS.map((s) => (
              <div key={s.num} className="step">
                <div className="step-number">{s.num}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <PricingSection />

      {/* Footer */}
      <footer className="footer">
        AgencyOS by <a href="https://docs.agencyos.network" target="_blank" rel="noopener noreferrer">Mekong CLI</a>
        {' | '}
        <a href="https://api.agencyos.network/health" target="_blank" rel="noopener noreferrer">API Status</a>
        {' | '}
        <a href="https://docs.agencyos.network" target="_blank" rel="noopener noreferrer">Documentation</a>
        {' | '}
        <a href="https://raas.agencyos.network" target="_blank" rel="noopener noreferrer">RaaS</a>
      </footer>
    </>
  )
}

export default App
